import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { environment } from 'src/environments/environment';
import { filter, take, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { HttpClient } from '@angular/common/http';

interface incubDis {
  district: string;
}
@Component({
  selector: 'app-incubatee-add',
  templateUrl: './incubatee-add.component.html',
  styleUrls: ['./incubatee-add.component.css'],
})
export class IncubateeAddComponent implements OnInit {
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  incubateeForm: FormGroup;
  private saveApi = environment.url + environment.incubateeSave;
  private getApi = environment.url + environment.incubateeGet;
  datas = 'Add';
  /**
   * Constructor to initialize the IncubateeAddComponent
   *
   * @param router - Router service for navigation
   * @param fb - FormBuilder service to create forms
   * @param makeapi - ApiService for making API requests
   * @param notify - NotifyService to show notifications
   * @param sanitizer - DomSanitizer to sanitize HTML content
   * @param route - ActivatedRoute to handle route parameters
   * @param http - HttpClient for HTTP requests
   * @param httpClient - HttpClient for HTTP requests (duplicate)
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private notify: NotifyService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private http: HttpClient,
    private httpClient: HttpClient
  ) {
    // Initialize the form for incubatee details
    this.incubateeForm = this.fb.group({
      id: [0], // Default ID set to 0
      incubatorId: ['', [Validators.required]], // Incubator ID must be provided
      incubateeName: ['', [Validators.required]], // Incubatee name must be provided
      email: ['', [Validators.required, Validators.email]], // Valid email required
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'), // Valid 10-digit phone number
        ],
      ],
      startupName: ['', [Validators.required]], // Startup name must be provided
      incubateeStage: ['', [Validators.required]], // Stage of incubatee must be provided
      availedSchemes: ['', [Validators.required]], // Schemes availed must be provided
      registeredDistrict: ['', [Validators.required]], // Registered district must be provided
      incorporatedDate: ['', [Validators.required]], // Incorporated date must be provided
      incorporationNoOrCIN: ['', [Validators.required]], // Incorporation number or CIN required
      registerNoOrRecognitionNo: ['', [Validators.required]], // Registration or recognition number required
      registeredDate: ['', [Validators.required]], // Registered date must be provided
      founderName: ['', [Validators.required]], // Founder name must be provided
      femaleFounder: [''], // Information if there is a female founder
      supportReceivedDate: ['', [Validators.required]], // Date when support was received
      supportDetails: ['', [Validators.required]], // Details of the support received
      logoFile: [null], // File for the logo
      logoFileName: [null], // Name of the logo file
      profileBrief: ['', [Validators.required]], // Brief profile description required
      industrySector: ['', [Validators.required]], // Industry sector must be provided
      otherDistrict: [''], // Other district information
      state: [null], // State information
      country: [null], // Country information
      scstFounder: [''], // Information if SC/ST founder exists
    });
  }
  get add() {
    return this.incubateeForm.controls;
  }
  roleValue;
  savelbl = 'Save';

  /**
   * Initialization method for the IncubateeAddComponent
   */
  ngOnInit(): void {
    // Get the role from the session storage
    this.roleValue = sessionStorage.getItem('role');

    // Get the user ID from the session storage
    let id: number = +sessionStorage.getItem('userId');

    // Subscribe to the route parameters and get the ID
    this.route.queryParams
      .pipe(
        // Filter the parameters to only get the _id parameter
        filter((params) => params._id)
      )
      .subscribe((params) => {
        // Set the datas variable to 'Update'
        this.datas = 'Update';

        // Set the save button label to 'Update'
        this.savelbl = 'Update';

        // Make an API call to get the incubatee details
        this.getIncubateeDetails(atob(params._id));
      });

    // Get the form values
    let getform = this.incubateeForm.value;

    // Set the incubator ID in the form
    getform.incubatorId = id;

    // Patch the form values
    this.incubateeForm.patchValue(getform);

    // Make an API call to get the schemes list
    this.schemesListApi();

    // Make an API call to get the district list
    this.districtList();
  }
  districtValues = [];
  /**
   * Function to get the district list from the assets/json/district.json file
   */
  districtList() {
    /**
     * Make an API call to get the district list
     */
    this.httpClient.get<any>('assets/json/district.json').subscribe((data) => {
      /**
       * Set the districtValues variable to the data received from the API call
       */
      this.districtValues = data;

      /**
       * Set the incubatorDistrictList variable to the districtValues
       */
      this.incubatorDistrictList = this.districtValues;

      /**
       * Call the filterIncubetorDistrict function to filter the district list
       */
      this.filterIncubetorDistrict();
    });
  }
  searchValue = false;
  searchList = [];
  /**
   * Function to select the incubator
   * @param value The selected incubator ID
   */
  selectIncubator(value: number) {
    /**
     * Set the searchValue variable to true
     */
    this.searchValue = true;
    /**
     * Reset the searchList array
     */
    this.searchList = [];
  }
  // district search
  protected incubatorDistrictList: incubDis[] = [];
  public District: FormControl = new FormControl();
  public DistrictFilterCtrl: FormControl = new FormControl();
  public incubatorDistrictFilterCtrl: FormControl = new FormControl();
  public incubatorDistrictListValue = new ReplaySubject(1);
  public DistrictListValue = new ReplaySubject(1);
  protected _onDisDestroy = new Subject();
  @ViewChild('DistrictSelect', { static: true }) DistrictSelect: MatSelect;
  /**
   * Function to filter the incubator district list based on the user's input
   * Subscribes to the value changes of the filter control and calls the filterDistrict function
   */
  filterIncubetorDistrict() {
    /**
     * Set the default value of the district select control to the first element in the list
     */
    this.District.setValue(this.incubatorDistrictList[1]);

    /**
     * Set the initial value of the incubator district list
     */
    this.incubatorDistrictListValue.next(this.incubatorDistrictList);

    /**
     * Subscribe to the value changes of the filter control
     * When the value changes, call the filterDistrict function
     */
    this.incubatorDistrictFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDisDestroy))
      .subscribe(() => {
        this.filterDistrict();
      });
  }
  /**
   * Sets the initial value of the incubator select control.
   * Subscribes to the first value of the incubator list value and sets the compareWith
   * function of the singleSelect control to compare the incubator name strings.
   */
  protected setInitialIncubetorYear() {
    /**
     * Take the first value of the incubator list value
     */
    this.incubatorDistrictListValue
      .pipe(
        // Take the first value of the incubator list value
        take(1),
        // Automatically unsubscribe on component destroy
        takeUntil(this._onDisDestroy)
      )
      .subscribe(() => {
        // Compare the incubator name strings
        this.DistrictSelect.compareWith = (a: incubDis, b: incubDis) =>
          a && b && a.district === b.district;
      });
  }
  /**
   * Filters the district list based on the current value of the filter control.
   * Updates the incubator district list value with the filtered results.
   */
  protected filterDistrict() {
    // Check if the district list is available
    if (!this.incubatorDistrictList) {
      return;
    }

    // Get the current search term from the filter control
    let search = this.incubatorDistrictFilterCtrl.value;

    if (!search) {
      // If no search term is provided, return the full list
      this.incubatorDistrictListValue.next(this.incubatorDistrictList.slice());
      return;
    } else {
      // Use the existing search term as-is
      search = search.toLowerCase();
    }

    // Filter the district list based on the search term and update the list value
    this.incubatorDistrictListValue.next(
      this.incubatorDistrictList.filter(
        (val) => val.district.toLowerCase().indexOf(search) > -1
      )
    );
  }
  schemesList: any = [];
  /**
   * Fetches the list of schemes from the schemes.json file and assigns it to the schemesList
   * variable.
   */
  schemesListApi() {
    /**
     * Make a GET request to the schemes.json file
     */
    this.http.get<any>('/assets/json/schemes.json').subscribe((data) => {
      /**
       * Assign the data received from the API call to the schemesList variable
       */
      this.schemesList = data;
    });
  }
  incorporatedDate;
  registeredDate;
  supportReceivedDate;
  image_url: any;
  /**
   * Retrieves the incubatee details from the server and patches the form with the data.
   * The retrieved data includes the incorporated date, registered date, and support received date.
   * The dates are converted to the correct format for the datepickers.
   * Also, the district list is fetched and the selected district is set.
   * Finally, the image is set if it exists, otherwise the default image is used.
   * @param id The id of the incubatee to retrieve.
   */
  getIncubateeDetails(id) {
    this.makeapi
      .method(this.getApi + 'id=' + id, '', 'get')
      .subscribe((data) => {
        // Set the femaleFounder value to true or false based on the value from the database
        if (data.femaleFounder == 'Yes') {
          data.femaleFounder = true;
        } else {
          data.femaleFounder = false;
        }

        // Patch the incubatee form with the retrieved data
        this.incubateeForm.patchValue(data);

        // Fetch the district list
        this.districtList();

        // Set the selected district
        this.DistrictFilterCtrl.setValue(data.registeredDistrict);

        // Set the incorporated date
        if (data.incorporatedDate != '') {
          let splitValue = data.incorporatedDate.split('/');
          let date: number = +splitValue[0];
          let month: number = +splitValue[1] - 1;
          let year: number = +splitValue[2];
          this.incorporatedDate = new Date(Date.UTC(year, month, date));
        }

        // Set the registered date
        if (data.registeredDate != '') {
          let splitValue = data.registeredDate.split('/');
          let date: number = +splitValue[0];
          let month: number = +splitValue[1] - 1;
          let year: number = +splitValue[2];
          this.registeredDate = new Date(Date.UTC(year, month, date));
        }

        // Set the support received date
        if (data.supportReceivedDate != '') {
          let splitValue = data.supportReceivedDate.split('/');
          let date: number = +splitValue[0];
          let month: number = +splitValue[1] - 1;
          let year: number = +splitValue[2];
          this.supportReceivedDate = new Date(Date.UTC(year, month, date));
        }

        // Set the image
        if (data.logoFileName != null) {
          this.image_urls = data.logoFileName;
          this.ImageValues = data.incubatorLogoFile;
          this.img_names = data.logoFileName;
        } else {
          this.image_url = 'assets/images/photo.png';
        }

        // Set the selected district
        if (data.registeredDistrict == 'Other') {
          this.seletedDistrict('Other');
        }
      });
  }
  ImageValues: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/photo.png';
  img_names = '';
  image_urls: any = 'assets/images/photo.png';
  img: any;
  logoCheck = false;
  maxSizeMB = 10;
  /**
   * Select an image and set the selected image value, image name, and image URL.
   * The image size is checked and the image is only accepted if it is less than
   * the maximum allowed size.
   * The image type is checked and the image is only accepted if it is a valid
   * image format (jpeg, jpg, png).
   * @param event - The event triggered when an image is selected.
   */
  onSelectImage(event) {
    this.selecetdImage = event.target.files[0];
    if (event.target.files && this.selecetdImage) {
      // Check the image size
      const fileSizeMB = this.selecetdImage.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        // If the image size is larger than the maximum allowed size, set the
        // logoCheck to true and return
        this.logoCheck = true;
        return;
      }

      // Read the selected image
      let reader = new FileReader();
      let data = this.selecetdImage;
      this.imagetype = data.type;
      let imagedatatype = this.imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        // Check if the image type is valid
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png'
      ) {
        // If the image type is valid, set the image value, image name, and image
        // URL
        this.img = '';
        this.fileValue = this.selecetdImage;
        reader.readAsDataURL(this.fileValue);
        reader.onload = () => {
          let splType = this.selecetdImage.type.split('/');
          this.url1 = reader.result;
          let spl = this.url1.split(',');
          this.ImageValues = spl[1];
          this.img_names = this.fileValue.name;
          this.logoCheck = false;
          this.image_urls = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url1
          );
        };
      } else {
        // If the image type is invalid, set the img to 'show' and notify the user
        this.img = 'show';
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }
  otherAddress = false;
  /**
   * When the district is changed, this function is called
   * @param event the value of the district
   */
  seletedDistrict(event) {
    // If the district is 'Other', then show the other district, state and country fields
    if (event == 'Other') {
      this.otherAddress = true;
      // Set the validators for the other district, state and country fields
      this.incubateeForm.controls['otherDistrict'].setValidators([
        Validators.required,
      ]);
      this.incubateeForm.controls['state'].setValidators([Validators.required]);
      this.incubateeForm.controls['country'].setValidators([
        Validators.required,
      ]);
    } else {
      // If the district is not 'Other', then hide the other district, state and country fields
      this.otherAddress = false;
      // Clear the values of the other district, state and country fields
      this.incubateeForm.controls['otherDistrict'].setValue(null);
      this.incubateeForm.controls['state'].setValue(null);
      this.incubateeForm.controls['country'].setValue(null);
      // Clear the validators of the other district, state and country fields
      this.incubateeForm.controls['otherDistrict'].clearValidators();
      this.incubateeForm.controls['state'].clearValidators();
      this.incubateeForm.controls['country'].clearValidators();
    }
    // Update the validity of the form
    this.incubateeForm.controls['otherDistrict'].updateValueAndValidity();
    this.incubateeForm.controls['state'].updateValueAndValidity();
    this.incubateeForm.controls['country'].updateValueAndValidity();
  }
  /**
   * Save the incubatee
   * @param event the save button click event
   */
  saveIncubatee() {
    let getform = this.incubateeForm.value;
    if (this.incubateeForm.invalid) {
      // If the form is invalid, mark all the fields as touched and show an
      // error notification
      this.incubateeForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // If the form is valid, prepare the data to be sent to the API
      if (this.ImageValues != '') {
        // Set the logo file name and value
        getform.logoFileName = this.img_names;
        getform.logoFile = this.ImageValues;
      }
      // Format the dates if they are in object format
      if (typeof getform.incorporatedDate === 'object') {
        let incorporatedDate = moment(getform.incorporatedDate).format(
          'DD/MM/YYYY'
        );
        if (incorporatedDate != 'Invalid date') {
          getform.incorporatedDate = incorporatedDate;
        }
      }
      if (typeof getform.registeredDate === 'object') {
        let registeredDate = moment(getform.registeredDate).format(
          'DD/MM/YYYY'
        );
        if (registeredDate != 'Invalid date') {
          getform.registeredDate = registeredDate;
        }
      }
      if (typeof getform.supportReceivedDate === 'object') {
        let supportReceivedDate = moment(getform.supportReceivedDate).format(
          'DD/MM/YYYY'
        );
        if (supportReceivedDate != 'Invalid date') {
          getform.supportReceivedDate = supportReceivedDate;
        }
      }
      // Set the female founder value to 'Yes' or 'No'
      if (getform.femaleFounder == true) {
        getform.femaleFounder = 'Yes';
      } else {
        getform.femaleFounder = 'No';
      }

      // Call the API to save the incubatee
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        if (data.responseStatus == 'Success') {
          // Show a success notification and navigate to the list page
          this.notify.notifysuccess(data.responseMessage);
          this.cancelIncubatee();
        } else {
          // Show an error notification
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Cancels the incubatee form and navigates to the incubatee list page.
   */
  cancelIncubatee() {
    // Reset the form
    this.incubateeForm.reset();
    // Navigate to the incubatee list page
    this.router.navigate(['admin', 'incubatee']);
  }
}
